"use client"

import { HttpTypes } from "@medusajs/types"
import Image from "next/image"
import { useState } from "react"
import { useTranslate } from "@tolgee/react"

export const BarebonesProductGallery = ({
  images,
}: {
  images: HttpTypes.StoreProduct["images"]
}) => {
  const { t } = useTranslate()
  const slides = images?.length ? images : []
  const [active, setActive] = useState(0)
  const current = slides[active] || slides[0]

  if (!current) {
    return (
      <div className="aspect-square w-full bg-[#ece8e2]" aria-hidden />
    )
  }

  return (
    <div className="bb-pdp-gallery w-full">
      <div className="relative aspect-square w-full overflow-hidden bg-[#ece8e2]">
        {current.url.endsWith(".mp4") ? (
          <video
            key={current.id}
            controls
            className="h-full w-full object-cover"
            src={decodeURIComponent(current.url)}
          />
        ) : (
          <Image
            key={current.id}
            src={decodeURIComponent(current.url)}
            alt={t("product_carousel.image_alt", "Product image")}
            fill
            sizes="(max-width: 1024px) 100vw, 58vw"
            quality={90}
            className="object-cover"
            priority
          />
        )}
      </div>

      {slides.length > 1 && (
        <div className="bb-pdp-thumbs mt-3 flex gap-2 overflow-x-auto pb-1">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`View image ${index + 1}`}
              aria-current={index === active}
              onClick={() => setActive(index)}
              className={`bb-pdp-thumb relative h-20 w-20 shrink-0 overflow-hidden border transition-opacity ${
                index === active
                  ? "border-[#2b2118] opacity-100"
                  : "border-transparent opacity-70 hover:opacity-100"
              }`}
            >
              <Image
                src={decodeURIComponent(slide.url)}
                alt=""
                fill
                sizes="80px"
                className="object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
